import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { ApiConfigurationEntity } from './api-configuration.entity';
import { BaseEntity } from './base.entity';
import { RbacActionEntity } from './rbac-action.entity';

@Index('_fk__api_configuration__id', ['fkApiConfigurationId'], {})
@Index('_fk__rbac_action__id', ['fkRbacActionId'], {})
@Entity('_api_configuration__rbac_action')
export class ApiConfigurationRbacActionEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__api_configuration__id',
		nullable: true,
		unsigned: true,
	})
	public fkApiConfigurationId!: number | null;

	@Column('int', {
		name: '_fk__rbac_action__id',
		nullable: true,
		unsigned: true,
	})
	public fkRbacActionId!: number | null;

	@ManyToOne(
		() => ApiConfigurationEntity,
		(apiConfiguration) => apiConfiguration.apiConfigurationRbacActions,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__api_configuration__id', referencedColumnName: 'id' },
	])
	public fkApiConfiguration!: ApiConfigurationEntity;

	@ManyToOne(
		() => RbacActionEntity,
		(rbacAction) => rbacAction.apiConfigurationRbacActions,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__rbac_action__id', referencedColumnName: 'id' }])
	public fkRbacAction!: RbacActionEntity;
}
